import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Only Amplify is exported from aws-amplify, not Logger
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';      // generated by `amplify push`
Amplify.configure(awsExports);



// Console log if needed for debugging (Logger is NOT available):
console.log('[Amplify] configured with endpoint:', awsExports.aws_appsync_graphqlEndpoint);

// optional devtools disable you already had
if (process.env.NODE_ENV === 'production') {
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
    for (let [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value === 'function' ? () => {} : null;
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();